import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  createKnockStatus,
  updateKnockStatus,
} from '@user/store/knockStatus/api'
import { KnockStatusInput } from '@user/store/knockStatus/typings'
import {
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferences,
  userGeneralPreferencesList,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { toast } from '@sales-center/components'

export const useAddKnockStatusHandlers = (onClose: () => void) => {
  const dispatch = useAppDispatch()
  const userGeneralPreferences = useSelector(userGeneralPreferencesList)

  const handleSubmit = useCallback(
    async (values: KnockStatusInput) => {
      try {
        values.name = values.name.trim()
        if (values.id) {
          await dispatch(updateKnockStatus(values)).unwrap()
          toast.success('Knock status updated successfully')
        } else {
          const createdStatus = await dispatch(
            createKnockStatus(values),
          ).unwrap()
          const mapViewFilteredKnockStatusesPreference =
            userGeneralPreferences?.find(
              (pref) =>
                pref.type ===
                IUserPreferenceGeneralListItemType.MapViewFilteredKnockStatuses,
            )
          const existingPreferenceValue =
            mapViewFilteredKnockStatusesPreference?.value ?? ''

          if (existingPreferenceValue !== '') {
            const nextSelectedIds =
              existingPreferenceValue === 'none'
                ? [String(createdStatus.id)]
                : existingPreferenceValue.split('_').filter(Boolean)

            if (!nextSelectedIds.includes(String(createdStatus.id))) {
              nextSelectedIds.push(String(createdStatus.id))
              await dispatch(
                saveGeneralPreferences({
                  type: IUserPreferenceGeneralListItemType.MapViewFilteredKnockStatuses,
                  value: nextSelectedIds.join('_'),
                }),
              )
            }
          }
          toast.success('Knock status created successfully')
        }
        onClose()
      } catch (error: any) {
        toast.error(
          error?.Message || 'An error occurred while saving the knock status',
        )
      }
    },
    [dispatch, onClose, userGeneralPreferences],
  )

  return {
    handleSubmit,
  }
}
